import React from 'react';
import { colors } from '../../styles/colors';

/**
 * JoursParConsultantTable - Tableau des jours travaillés par mois et par consultant
 *
 * Affiche un tableau avec les mois en lignes et les consultants en colonnes.
 * Les valeurs sont formatées en 1 décimale avec opacité et font-weight dynamiques.
 *
 * @param {Object} props
 * @param {Array} props.data - [{mois: 1, consultant1: 10.5, consultant2: 8.0, ...}]
 * @param {Array} props.consultants - ['Consultant A', 'Consultant B', ...]
 * @param {number} props.selectedYear - Année pour formater les mois
 */
function JoursParConsultantTable({ data, consultants, selectedYear }) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontFamily: '"Noto Sans", sans-serif',
        fontSize: '0.8rem'
      }}>
        <thead>
          <tr style={{ backgroundColor: colors.primary.gray }}>
            <th style={{
              padding: '0.25rem 1rem',
              textAlign: 'left',
              fontSize: '0.875rem',
              fontWeight: '600',
              color: colors.text.white,
              borderBottom: `2px solid ${colors.secondary.mediumGray}`
            }}>
              Mois
            </th>
            {consultants.map(consultant => (
              <th
                key={consultant}
                style={{
                  padding: '0.25rem 1rem',
                  textAlign: 'center',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: colors.text.white,
                  borderBottom: `2px solid ${colors.secondary.mediumGray}`
                }}
              >
                {consultant}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={row.mois}
              style={{
                backgroundColor: index % 2 === 0 ? colors.text.white : colors.secondary.lightGray,
                borderBottom: `1px solid ${colors.secondary.lightGray}`
              }}
            >
              <td style={{
                padding: '0.25rem 1rem',
                fontWeight: '600',
                color: colors.primary.teal
              }}>
                {new Date(selectedYear, row.mois - 1).toLocaleString('fr-FR', { month: 'long' })}
              </td>
              {consultants.map(consultant => (
                <td
                  key={consultant}
                  style={{
                    padding: '0.25rem 1rem',
                    textAlign: 'center',
                    color: colors.primary.gray,
                    fontWeight: (row[consultant] || 0) > 0 ? '500' : '400',
                    opacity: (row[consultant] || 0) > 0 ? 1 : 0.5
                  }}
                >
                  {(row[consultant] || 0).toFixed(1)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default JoursParConsultantTable;
